import React from "react";
import Api from "../../servicios/api";
import { Link } from "react-router-dom";
import FormUsuario from "./Usuarios"
import findImage from "../../images/find.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Swal from 'sweetalert2';
import { faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight, faFilter, faTimes, faSearch, faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons'
import * as XLSX from 'xlsx';

class Auditorias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editar: 'No',
            load: '',
            datosCargados: false,
            ordenes: [],
            empresas: [],
            municipios: [],
            infoAuditoria : [],
            excel: 0,
            showFilters: false,
            auditoriaData: {
                orden: '',
                observaciones: '',
                estado: 'En proceso'
            },
            infoPaciente: '',
            Faltantes:0,
            infoAtenciones: [],
            infoDetalle: [],
            infoInsumos: [],recetas:[],incapacidades:[],
            infoMedicamentos: [],iframeUrl: '', showIframe: false
        };
    }

    resetForm() {
        document.getElementById('form').reset();
        document.getElementById('ordenint').focus();
    }

    toggleFilters = () => {
        this.setState(prevState => ({ showFilters: !prevState.showFilters }));
    }

    handleAuditoriaChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            auditoriaData: {
                ...prevState.auditoriaData,
                [name]: value
            }
        }));
    }

    handleAuditoriaSubmit = () => {
         var orden = document.getElementById('ordenAuditoria').value;
        var obs = document.getElementById('observacionesAuditoria').value;
        var estado = document.getElementById('estadoAuditoria').value;
        var usuario = localStorage.getItem('k_usuario');
        if(obs==''){
            alert("Debes de llenar la observacion");
            return false;
        }
        if(estado==''){
            alert("Debes de seleccionar el estado");
            return false;
        }
  
        let datos = JSON.stringify({ usuario, orden, obs, estado});

        Swal.showLoading();
        fetch(Api + "Ordenes/AddAuditoria", {
            method: "POST",
            body: datos
        })
            .then(respuesta => respuesta.json())
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.fire(
                    'Atencion!',
                    datosRespuesta.msj,
                    'success'
                )
                this.BuscarOrden(1);
                
            })
            .catch(console.log)
    }

    cargarEmpresas() {
        fetch(Api + "Empresas")
            .then(respuesta => respuesta.json())
            .then((datosEmpresas) => {
                this.setState({ empresas: datosEmpresas.data })
            })
            .catch(console.log);
    }

    cargarMunicipios() {
        fetch(Api + "Municipios/08")
            .then(respuesta => respuesta.json())
            .then((datosMunicipios) => {
                this.setState({ municipios: datosMunicipios });
                this.municipio.focus();
            })
            .catch(console.log)
    }

    componentDidMount() {
        this.BuscarOrden(1);
        this.cargarEmpresas();
        this.cargarMunicipios();
    }

    Excel() {
        // Obtener valores del formulario
        let ordenint = document.getElementById('ordenint').value;
        let ordenext = document.getElementById('ordenext').value;
        let cedula = document.getElementById('cedula').value;
        let nombre = document.getElementById('nombre').value;
        let empresa = document.getElementById('empresa').value;
        let municipio = document.getElementById('municipio').value;
        let covid = document.getElementById('covid').value;
        let apellidox = document.getElementById('apellidox').value;
        let estado = document.getElementById('estado').value;
        let factura = document.getElementById('factura').value;
        let revisada = document.getElementById('revisada').value;
        let usuario = document.getElementById('usuario').value;
        let fechain = document.getElementById('fechain').value;
        let fechaout = document.getElementById('fechaout').value;
        let prueba = document.getElementById('prueba').value;
        let resultado = document.getElementById('resultado').value;

        // Validar campos requeridos
        if (!empresa) {
            Swal.fire({
                icon: 'error',
                title: 'Campo requerido',
                text: 'Debes seleccionar una empresa para exportar',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        if (!fechain || !fechaout) {
            Swal.fire({
                icon: 'error',
                title: 'Fechas requeridas',
                text: 'Debes seleccionar un rango de fechas para exportar',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        // Mostrar alerta de carga
        Swal.fire({
            title: 'Preparando archivo...',
            html: 'Generando reporte de órdenes',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Formatear fechas a yyyy/mm/dd
        const formatDate = (dateString) => {
            if (!dateString) return '';
            const [year, month, day] = dateString.split('-');
            return `${year}/${month}/${day}`;
        };

        // Datos para enviar al endpoint
        const requestData = {
            empresa: empresa,
            fecha_inicio: formatDate(fechain),
            fecha_final: formatDate(fechaout),
            estado: estado
        };
        let datos = JSON.stringify({ ordenint, ordenext, cedula, nombre, apellidox, empresa, municipio, covid, estado, factura, revisada, usuario, fechain, fechaout, prueba, resultado });
        // Consumir el endpoint
        fetch('https://backidb.softmediko.com/api/Ordenes/ExportarExcel', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: datos
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error al obtener los datos');
                }
                return response.json();
            })
            .then(data => {
                // Verificar si hay datos
                if (!data.datos || data.datos.length === 0) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Sin datos',
                        text: 'No se encontraron órdenes para exportar',
                        confirmButtonText: 'Aceptar'
                    });
                    return;
                }

                // Preparar los datos para Excel con todos los campos
                const datosFormateados = data.datos.map(item => ({
                    // Información básica del paciente
                    'ORDEN INTERNA': item.orden_servicio,
                    'ORDEN EXTERNA': item.orden_externa,
                    'TIPO DOCUMENTO': item.documento,
                    'DOCUMENTO': item.numero_doc,
                    'NOMBRE COMPLETO': `${item.nombres} ${item.nombre2 || ''} ${item.apellidos} ${item.apellido2 || ''}`.trim(),
                    'DIRECCIÓN': item.direccion1,
                    'BARRIO': item.barrio,
                    'EMAIL': item.email1,
                    'CELULAR': item.celular,
                    'SEXO': item.sexo,
                    'EDAD': item.edad,
                    'FECHA NACIMIENTO': item.fecha_nacimiento,
                    'FECHA REGISTRO PAC': item.fecha_reg.split(' ')[0],
                    'ACUDIENTE': item.nombre_acudiente,

                    // Información médica
                    'ESTADO PROGRAMA': item.estado_paciente,
                    'DIAGNÓSTICO CÓDIGO': item.enfermedad,
                    'DIAGNÓSTICO DESCRIPCIÓN': item.descripcion_enf,
                    'CÓDIGO ATENCIÓN': item.cod_aten,
                    'DESCRIPCIÓN SERVICIO': item.Description,
                    'FECHA INICIO': item.StartTime,
                    'FECHA FIN': item.EndTime,
                    'CANTIDAD': item.cant,
                    'CADA': item.cada,
                    'PAQUETE': item.paquete,

                    // Información de atención
                    'PROFESIONAL': item.user,
                    'FECHA REGISTRO TA': item.fecha_reg_ta,
                    'FECHA MODIFICACIÓN TA': item.fecha_mod_ta,
                    'PRECIO TOTAL': item.precio_total,
                    'CANTIDAD MED': item.cant_med,
                    'PORCENTAJE': item.id_contacto,
                    'TIPO CONSULTA': item.tipo_consulta === 1 ? 'Ingreso' : 'Evolucion',
                    'FACTURA': item.relacionado,
                    'REVISADAS': item.Location,

                    // Información clínica
                    'INFORMACIÓN ADICIONAL': item.inf_adicional ? item.inf_adicional.replace(/\n/g, ' ') : '',
                    'VALORACIÓN': item.Valoracion ? item.Valoracion.replace(/\n/g, ' ') : '',
                    'EXAMEN FÍSICO': item.examen_fisico,
                    'ANTECEDENTES FAMILIARES': item.antecedentes_familiares,
                    'PROCEDIMIENTOS': item.procedimientos,
                    'DATOS ANTROPOMÉTRICOS': item.datos_antropometricos,
                    'EVOLUCIÓN': item.evolucion
                }));

                // Crear libro de Excel
                const ws = XLSX.utils.json_to_sheet(datosFormateados);

                // Ajustar anchos de columnas
                const wscols = [
                    { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 15 }, { wch: 30 },
                    { wch: 30 }, { wch: 20 }, { wch: 25 }, { wch: 20 }, { wch: 10 }, { wch: 10 },
                    { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 },
                    { wch: 30 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
                    { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
                    { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 50 }, { wch: 10 }, { wch: 10 }, { wch: 100 },
                    { wch: 50 }, { wch: 50 }, { wch: 50 }, { wch: 50 }, { wch: 50 }
                ];
                ws['!cols'] = wscols;

                // Estilo para encabezados
                const headerStyle = {
                    font: { bold: true, color: { rgb: "FFFFFF" } },
                    fill: { fgColor: { rgb: "4F81BD" } },
                    alignment: { horizontal: "center" }
                };

                // Aplicar estilo a encabezados
                const range = XLSX.utils.decode_range(ws['!ref']);
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cell = XLSX.utils.encode_cell({ c: C, r: 0 });
                    if (!ws[cell]) ws[cell] = {};
                    ws[cell].s = headerStyle;
                }

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Órdenes");

                // Generar nombre de archivo
                const fechaHoy = new Date().toISOString().slice(0, 10).replace(/-/g, '');
                const nombreArchivo = `Ordenes_${empresa}_${fechaHoy}.xlsx`;

                // Descargar archivo
                XLSX.writeFile(wb, nombreArchivo);

                // Cerrar alerta de carga
                Swal.close();
            })
            .catch(error => {
                console.error('Error:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error en la exportación',
                    text: 'Ocurrió un problema al generar el archivo: ' + error.message,
                    confirmButtonText: 'Entendido'
                });
            });
    }

 
    BuscarOrden(page) {
        console.log("Formulario Enviado...");
        let ordenint = document.getElementById('ordenint').value;
        let ordenext = document.getElementById('ordenext').value;
        let cedula = document.getElementById('cedula').value;
        let nombre = document.getElementById('nombre').value;
        let empresa = document.getElementById('empresa').value;
        let municipio = document.getElementById('municipio').value;
        let covid = document.getElementById('covid').value;
        let apellidox = document.getElementById('apellidox').value;
        let estado = document.getElementById('estado').value;
        let factura = document.getElementById('factura').value;
        let revisada = document.getElementById('revisada').value;
        let usuario = document.getElementById('usuario').value;
        let fechain = document.getElementById('fechain').value;
        let fechaout = document.getElementById('fechaout').value;
        let prueba = document.getElementById('prueba').value;
        let resultado = document.getElementById('resultado').value;
        let estado_aud = document.getElementById('estado_aud').value;
        this.setState({ load: 'Cargando Datos...' })
        let datos = JSON.stringify({ estado_aud,ordenint, ordenext, cedula, nombre, apellidox, empresa, municipio, covid, estado, factura, revisada, usuario, fechain, fechaout, prueba, resultado });
        let formData = datos;
        this.setState({ load: 'Cargando Datos...' })
        fetch(Api + "Ordenes/ListaAuditoria?page=" + page, {
            method: "POST",
            body: formData
        })
            .then(respuesta => respuesta.json())
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                this.setState({ excel: 1, datosCargados: true, load: '', ordenes: datosRespuesta.datos.data, pagina: datosRespuesta.datos.total, ultimo: datosRespuesta.datos.last_page, actual: datosRespuesta.datos.current_page });
            })
            .catch(console.log)
    }

    BuscarOrdenOld(page) {
        let ordenint = document.getElementById('ordenint').value;
        let ordenext = document.getElementById('ordenext').value;

        let cedula = document.getElementById('cedula').value;
        let nombre = document.getElementById('nombre').value;
        let apellidox = document.getElementById('apellidox').value;
        let empresa = document.getElementById('empresa').value;
        let municipio = document.getElementById('municipio').value;
        let covid = document.getElementById('covid').value;
        let estado = document.getElementById('estado').value;
        let factura = document.getElementById('factura').value;
        let revisada = document.getElementById('revisada').value;
        let usuario = document.getElementById('usuario').value;
        let fechain = document.getElementById('fechain').value;

        this.setState({ load: 'Cargando Datos...' })
        let datos = JSON.stringify({ ordenint, ordenext, cedula, nombre, apellidox, empresa, municipio, covid, estado, factura, revisada, usuario, fechain });
        console.log('arra:' + datos);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: { ordenint: ordenint }
        };
        fetch(Api + "Ordenes/Lista?page=" + page, requestOptions)
            .then(respuesta => respuesta.json())
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                this.setState({ datosCargados: true, load: '', ordenes: datosRespuesta.datos.data, pagina: datosRespuesta.datos.total, ultimo: datosRespuesta.datos.last_page, actual: datosRespuesta.datos.current_page });
            })
            .catch(console.log)
    }

 
  cargar(id) {
    Swal.showLoading();
    
    // Resetear valores del formulario
    document.getElementById('observacionesAuditoria').value = '';
    document.getElementById('estadoAuditoria').value = '';
    document.getElementById('ordenAuditoria').value = id;
    
    this.setState({ load: 'Cargando Datos...' });
    
    fetch(Api + "Ordenes/OrdenInterna/" + id, {
        method: "GET",
        headers: new Headers({
            'Authorization': 'koala2021'
        }),
    })
    .then((respuesta) => respuesta.json())
    .then((datosRespuesta) => {
        // Validación robusta de auditoria
        const auditoriaValida = datosRespuesta.auditoria && 
                              !Array.isArray(datosRespuesta.auditoria) && 
                              typeof datosRespuesta.auditoria === 'object' && 
                              Object.keys(datosRespuesta.auditoria).length > 0;
        
        // Actualizar estado con los datos
        this.setState({
            datosCargados: true,
            load: '',
            infoAtenciones: datosRespuesta.datos,
            infoAuditoria: auditoriaValida ? datosRespuesta.auditoria : null,
            infoDetalle: datosRespuesta.datos[0],
            infoPaciente: datosRespuesta.paciente,
            infoInsumos: datosRespuesta.insumos,
            infoMedicamentos: datosRespuesta.medicamentos,
            Faltantes: datosRespuesta.cantidad_faltantes,
            showIframe: true,
            iframeUrl: `https://idb.medikoala.com/VerOrdenInterna/${id}`
        });
        
        // Asignar valores solo si auditoria es válida
        if (auditoriaValida) {
            document.getElementById('observacionesAuditoria').value = 
                datosRespuesta.auditoria.observaciones || '';
            document.getElementById('estadoAuditoria').value = 
                datosRespuesta.auditoria.estado || '';
        }
        
        Swal.close();
    })
    .catch(error => {
        console.error('Error:', error);
        Swal.close();
    });
}
    render() {
        const { infoAtenciones,infoDetalle,infoPaciente,Faltantes,infoAuditoria, load, ordenes, empresas, municipios, pagina, ultimo, actual, showFilters,iframeUrl,showIframe } = this.state;
        return (
            <div className="content">
                <div className="content-wrapper">
                    <div className="content">
                        <div class="modal fade" id="usuarioAsignado" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="usuarioAsignadoLabel" aria-hidden="true">
                            <FormUsuario />
                        </div>

                  

                        <div className="modal fade" id="ordenesModal" tabIndex="-1" aria-labelledby="ordenesModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header bg-primary text-white">
                                        <h5 className="modal-title" id="auditoriaModalLabel">Orden Interna <span id='numero_orden'></span></h5>
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <table className="table table-hover table-condensed table-sm">
                                                                                    <thead className="thead-inverse">
                                                                                        <tr>
                                                                                            
                                                                                            <th className="align-middle">ATENCIÓN</th>
                                                                                            <th className="align-middle">ORDEN EXT.</th>
                                                                                            <th className="align-middle">VISITA #</th>
                                                                                            <th className="align-middle">CADA</th>
                                                                                            <th className="align-middle">FEC. VISITA</th>
                                                                                            <th className="align-middle">FEC. REGISTRO</th>
                                                                                           
                                                                                            <th className="align-middle">ESTADO</th>
                                                                                            <th className="align-middle">ASIGNADO A</th>
                                                                                            <th className="align-middle" title="Valoracion">Valoracion</th>
                                                                                            <th className="align-middle" title="Tratamiento">Tratamiento</th>
                                                                                            <th className="align-middle" title="Motivo de consulta">Motivo</th>
                                                                                            <th className="align-middle" title="Examen Fisico">Examen</th>
                                                                                            <th className="align-middle" title="Antecedentes Personales">Antecedentes</th>
                                                                                            <th className="align-middle" title="Procedimientos Realizados en la clinica">Procedimientos</th>
                                                                                            <th className="align-middle" title="Evolucion Diaria">Evolucion</th>
                                                                                            <th className="align-middle" title="Firma del paciente o familiar">Firmado</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {load}
                                                                                        {
                                                                                            infoAtenciones.map((itemAtenciones) => (
                                                                                                <tr key={itemAtenciones.Id}>
                                                                                                 
                                                                                                    <td className={itemAtenciones.estado == 'Completada' ? 'table-success' : 'table-danger'}>{itemAtenciones.Description} [<a href="#" data-bs-toggle='modal' data-bs-target='#myModalGestionar' onClick={() => this.veritem(itemAtenciones.Id)}>+</a>]</td>
                                                                                                    <td>{itemAtenciones.orden_externa}</td>
                                                                                                    <td>{itemAtenciones.cant_ins}</td>
                                                                                                    <td>{itemAtenciones.cada} Días</td>
                                                                                                    <td>{itemAtenciones.fecha_mod_ta}</td>
                                                                                                    <td>{itemAtenciones.registro}</td>
                                                                                                    
                                                                                                    <td>{itemAtenciones.estado}</td>
                                                                                                    <td>{itemAtenciones.user}</td>

                                                                                                    <td title={itemAtenciones.Valoracion} className={itemAtenciones.Valoracion != null ? 'table-success' : 'table-danger'}>{itemAtenciones.Valoracion != null ? 'OK' : 'X'}</td>
                                                                                                    <td title={itemAtenciones.inf_adicional} className={itemAtenciones.inf_adicional != null ? 'table-success' : 'table-danger'}>{itemAtenciones.inf_adicional != null ? 'OK' : 'X'}</td>
                                                                                                    <td title={itemAtenciones.motivo_consulta} className={itemAtenciones.motivo_consulta != null ? 'table-success' : 'table-danger'}>{itemAtenciones.motivo_consulta != null ? 'OK' : 'X'}</td>
                                                                                                    <td title={itemAtenciones.examen_fisico} className={itemAtenciones.examen_fisico != null ? 'table-success' : 'table-danger'}>{itemAtenciones.examen_fisico != null ? 'OK' : 'X'}</td>
                                                                                                    <td title={itemAtenciones.antecedentes_familiares} className={itemAtenciones.antecedentes_familiares != null ? 'table-success' : 'table-danger'}>{itemAtenciones.antecedentes_familiares != null ? 'OK' : 'X'}</td>
                                                                                                    <td title={itemAtenciones.procedimientos} className={itemAtenciones.procedimientos != null ? 'table-success' : 'table-danger'}>{itemAtenciones.procedimientos != null ? 'OK' : 'X'}</td>
                                                                                                    <td title={itemAtenciones.evolucion} className={itemAtenciones.evolucion != null ? 'table-success' : 'table-danger'}>{itemAtenciones.evolucion != null ? 'OK' : 'X'}</td>
                                                                                                    
                                                                                                    <td className={itemAtenciones.quien != null ? 'table-success' : 'table-danger'}>{itemAtenciones.quien != null ? 'Firmado' : 'Pendiente'}</td>
                                                                                                </tr>
                                                                                            ))
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                                <div className="modal-body" style={{ height: '80vh' }}>
                                                                                    {showIframe && (
                                                                                        <iframe 
                                                                                            src={iframeUrl}
                                                                                            title="Visualización de Orden Interna"
                                                                                            width="100%"
                                                                                            height="100%"
                                                                                            frameBorder="0"
                                                                                            style={{ border: 'none' }}
                                                                                        ></iframe>
                                                                                    )}
                                                                                </div>
                                                                                <form>
                                                                                        <div className="mb-3">
                                                                                            <label htmlFor="ordenAuditoria" className="form-label">Orden</label>
                                                                                            <input 
                                                                                                type="text" 
                                                                                                className="form-control" 
                                                                                                id="ordenAuditoria" 
                                                                                                name="orden"
                                                                                                
                                                                                                readOnly
                                                                                            />
                                                                                        </div>
                                                                                        <div className="mb-3">
                                                                                            <label htmlFor="observacionesAuditoria" className="form-label">Observaciones</label>
                                                                                            <textarea 
                                                                                                className="form-control" 
                                                                                                id="observacionesAuditoria" 
                                                                                                name="observaciones"
                                                                                                rows="3"
                                                                                              
                                                                                            ></textarea>
                                                                                        </div>
                                                                                        <div className="mb-3">
                                                                                            <label htmlFor="estadoAuditoria" className="form-label">Estado</label>
                                                                                            <select 
                                                                                                className="form-select" 
                                                                                                id="estadoAuditoria" 
                                                                                                name="estado"
                                                                                              
                                                                                            >
                                                                                                <option value="">Seleccione el estado</option>
                                                                                                <option value="Auditada">Auditada</option>
                                                                                                <option value="Revisar">Revisar</option>
                                                                                                
                                                                                            </select>
                                                                                        </div>
                                                                                    </form>
                                    </div>
                                    <div className="modal-footer">
                                        <button 
                                            type="button" 
                                            className="btn btn-primary"
                                            onClick={() => this.handleAuditoriaSubmit()}
                                        >
                                            Guardar Auditoría
                                        </button>
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" id="closeAuditoriaModal">Cancelar</button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h4>Preauditorias de Ordenes</h4>
                                    <button 
                                        className="btn btn-sm btn-primary" 
                                        onClick={this.toggleFilters}
                                    >
                                        <FontAwesomeIcon icon={showFilters ? faTimes : faSearch} /> {showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros'}
                                    </button>
                                </div>
                                <div className="card-body">
                                    <div id="form" className={showFilters ? '' : 'd-none'}>
                                        <div className="row">
                                            <div className="col-xl-2">
                                                <label htmlFor="ordenint">Orden Interna</label>
                                                <input type="text" id="ordenint" name="ordenint" placeholder="Orden Int." className="form-control form-control-sm" />
                                            </div>
                                            <div className="col-xl-2">
                                                <label htmlFor="ordenext">Orden Externa</label>
                                                <input type="text" id="ordenext" name="ordenext" placeholder="Orden Ext." className="form-control form-control-sm" />
                                            </div>
                                            <div className="col-xl-2">
                                                <label htmlFor="cedula">Identificación</label>
                                                <input type="text" id="cedula" name="cedula" placeholder="Identificación" className="form-control form-control-sm" />
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="nombre">Nombre Paciente</label>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <input type="text" id="nombre" name="nombre" placeholder="Nombre Paciente" className="form-control form-control-sm" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <input type="text" id="apellidox" name="apellidox" placeholder="apellido Paciente" className="form-control form-control-sm" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="empresa">Empresa</label>
                                                <select className="form-select form-select-sm" type="text" name="empresa" id="empresa">
                                                    <option value="">Seleccione la Empresa</option>
                                                    {
                                                        empresas.map(itemEmpresa => (
                                                            <option key={itemEmpresa.id_empresa} value={itemEmpresa.rips}>{itemEmpresa.nombre_emp}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row">
                                            <div className="col-xl-2">
                                                <label htmlFor="estado">Estado Orden</label>
                                                <select className="form-select form-select-sm" type="text" name="estado" id="estado">
                                                    <option value="99">Completada</option>
                                                    <option value="0">No Iniciada</option>
                                                    <option value="97">En Proceso</option>
                                                </select>
                                            </div>
                                            <div className="col-xl-2">
                                                <label htmlFor="factura">Facturadas</label>
                                                <select className="form-select form-select-sm" type="text" name="factura" id="factura">
                                                    <option value="">Seleccione el Estado</option>
                                                    <option value="activa">No Facturado</option>
                                                    <option value="Facturado">Facturado</option>
                                                    <option value="No Facturable">No Facturable</option>
                                                </select>
                                            </div>
                                            <div className="col-xl-2">
                                                <label htmlFor="revisada">Ordenes Revisadas</label>
                                                <select className="form-select form-select-sm" type="text" name="revisada" id="revisada">
                                                    <option value="">Seleccione el Estado</option>
                                                    <option value="x">Sin Revisar</option>
                                                    <option value="Revisado">Revisadas</option>
                                                </select>
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="municipio">Municipio</label>
                                                <select className="form-select form-select-sm" type="text" name="municipio" id="municipio">
                                                    <option value="">Seleccione el Municipio</option>
                                                    {
                                                        municipios.map(itemMunicipio => (
                                                            <option key={itemMunicipio.id} value={itemMunicipio.cod_mun}>{itemMunicipio.nombre_mun}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <label htmlFor="usuario" className="form-label">Asignado a</label>
                                                <input type="text" id="usuario" name="usuario" placeholder="Asignado a" className="form-control form-control-sm" readOnly />
                                            </div>
                                            <div className='col-md-1'>
                                                <label htmlFor="" className="form-label">&nbsp;</label>
                                                <img style={{ width: 40 }} className='form-control form-control-sm' src={findImage} alt="Asignado a" data-bs-toggle='modal' data-bs-target='#usuarioAsignado'
                                                />
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row">
                                            <div className="col-xl-1">
                                                <label htmlFor="covid">Ord Auditadas</label>
                                                <select className="form-select form-select-sm" type="text" name="covid" id="covid">
                                                    <option value="">No</option>
                                                    <option value="1">Si</option>
                                                    
                                                </select>
                                            </div>
                                            <div className="col-xl-1">
                                                <label htmlFor="covid">Actualizadas</label>
                                                <select className="form-select form-select-sm" type="text" name="estado_aud" id="estado_aud">
                                                    <option value="">No</option>
                                                    <option value="Actualizada">Si</option>
                                                    
                                                </select>
                                            </div>
                                            <div className="col-xl-2">
                                                <label htmlFor="prueba">Programa</label>
                                                <select className="form-select form-select-sm" type="text" name="prueba" id="prueba">
                                                    <option value="">Seleccione el Estado</option>
                                                    <option value="Agudo">Agudo</option>
                                                    <option value="Cronico">Cronico</option>
                                                </select>
                                            </div>
                                            <div className="col-xl-2">
                                                <label htmlFor="resultado">Tipo de consulta</label>
                                                <select className="form-select form-select-sm" type="text" name="resultado" id="resultado">
                                                    <option value="">Seleccione el Resultado</option>
                                                    <option value="1">Ingreso</option>
                                                    <option value="0">Evolucion</option>
                                                </select>
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="fechain">Fecha Ingreso Inicial</label>
                                                <input type="date" id="fechain" name="fechain" className="form-control form-control-sm" />
                                            </div>
                                            <div className="col-xl-3">
                                                <label htmlFor="fechaout">Fecha Ingreso Final</label>
                                                <input type="date" id="fechaout" name="fechaout" className="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row text-center">
                                            <div className="col-xl-12">
                                                <button id="bt" name="bt" className="btn btn-primary btn-sm" onClick={() => this.BuscarOrden(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>&nbsp;&nbsp;
                                              {/*   <button type="button" className="btn btn-danger btn-sm" onClick={() => this.resetForm()} ><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</button>
                                                <button type="button" className="btn btn-success btn-sm" onClick={() => this.Excel()} ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;Exportar Excel</button> */}
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className="row">
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">ORDEN INT.</th>
                                                    <th className="align-middle">AUDITORÍA</th>
                                                    <th className="align-middle">ORDEN EXT.</th>
                                                    <th className="align-middle">CEDULA</th>
                                                    <th className="align-middle">PACIENTE</th>
                                                    <th className="align-middle">FECHA ING.</th>
                                                    <th className="align-middle">FECHA ATE.</th>
                                                    <th className="align-middle">ATENCIÓN</th>
                                                    <th className="align-middle">CANT.</th>
                                                    <th className="align-middle">PORC.</th>
                                                    <th className="align-middle">ESTADO</th>
                                                    <th className="align-middle">REVISADO</th>
                                                    <th className="align-middle">FACTURADO</th>
                                                    <th className="align-middle">ASIGNADO</th>
                                                   
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {load && (
                                                    <tr>
                                                        <td colSpan="15" className="text-center">
                                                            <FontAwesomeIcon icon={faSpinner} spin /> {load}
                                                        </td>
                                                    </tr>
                                                )}
                                                {
                                                    ordenes.map((itemOrdenes) => (
                                                        <tr key={itemOrdenes.Id}>
                                                            <td>
                                                                <button 
                                                                    className="btn btn-primary btn-sm" 
                                                                    data-bs-toggle="modal" 
                                                                    data-bs-target="#ordenesModal"
                                                                    onClick={() => this.cargar(itemOrdenes.orden_servicio)}
                                                                >
                                                                    {itemOrdenes.orden_servicio}
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <button 
                                                                    className={itemOrdenes.auditoria==null?"btn btn-danger btn-sm":"btn btn-success btn-sm"} 
                                                                    data-bs-toggle="modal" 
                                                                    data-bs-target="#auditoriaModal"
                                                                    onClick={() => this.setState({
                                                                        auditoriaData: {
                                                                            ...this.state.auditoriaData,
                                                                            orden: itemOrdenes.orden_servicio
                                                                        }
                                                                    })}
                                                                >
                                                                    {itemOrdenes.auditoria==null?"Sin auditar":itemOrdenes.auditoria}
                                                                </button>
                                                            </td>
                                                            <td><b className={itemOrdenes.Location == 'Revisado' ? "bg-success" : ""}>{itemOrdenes.orden_externa}</b></td>
                                                            <td>{itemOrdenes.numero_doc}</td>
                                                            <td><Link to={"/InfoPacientes/" + itemOrdenes.id_paciente}>{itemOrdenes.nombres} {itemOrdenes.nombre2} {itemOrdenes.apellidos} {itemOrdenes.apellido2}</Link></td>
                                                            <td>{itemOrdenes.fecha_reg_ta}</td>
                                                            <td>{itemOrdenes.StartTime} - {itemOrdenes.EndTime}</td>
                                                            <td>{itemOrdenes.Description}</td>
                                                            <td>{itemOrdenes.cant}</td>
                                                            <td>{parseFloat(itemOrdenes.id_contacto ? itemOrdenes.id_contacto : 0).toFixed(2) + "%"}</td>
                                                            <td></td>
                                                            <td><b className={itemOrdenes.Location == 'Revisado' ? "bg-success" : ""}>{itemOrdenes.Location}</b></td>
                                                            <td>{itemOrdenes.prioridad}</td>
                                                            <td>{itemOrdenes.user}</td>
                                                          
                                                            
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarOrden(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarOrden(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                            {(() => {
                                                let p = [];
                                                p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarOrden(actual)}>{actual}</a></li>);
                                                return p;
                                            })()}
                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarOrden(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                            <li className="page-item"><a className="page-link" href="#" onClick={() => this.BuscarOrden(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                        </ul>
                                    </nav>
                                </div>
                                <div className="card-footer text-muted">
                                    <b>Pagina</b> <span class="badge bg-primary">{actual}</span> <b>de</b> <span class="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span class="badge bg-success">{pagina}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Auditorias;